
import { useKeystoneSession } from '../../../auth/use-keystone-session';
import { Avatar, Box, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList, MenuDivider, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { Moon, Sun, Hammer, Shield, Database } from 'lucide-react';
import { LogOut, Settings } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppRoles } from '@hooks';
import { hasRole } from '../../../auth/roles';
import { selectNavigation, useAppSelector } from '@state';

export const UserProfileControls = () => {
	const {
		status,
		user,
		signOut
	} = useKeystoneSession();

	const isAuthenticated = status === 'ready';

    const { toggleColorMode } = useColorMode();
    const text = useColorModeValue('dark', 'light');
    const SwitchIcon = useColorModeValue(Moon, Sun);
    const navigate = useNavigate();
    const location = useLocation();
    const appRoles = useAppRoles();
    const isAdmin = hasRole(appRoles, ['blueprint:super_admin', 'blueprint:admin']);
    const canManageProducts = hasRole(appRoles, ['blueprint:super_admin', 'blueprint:admin', 'blueprint:srblueprint']);
    const appNav = useAppSelector(selectNavigation);
    const inCadMode = location.pathname.startsWith('/r') || location.pathname.startsWith('/v');

	return (<>
		<Box w={'100%'} h={'100%'} m={'1px'} border={'0px'}>
			<HStack h="100%">
				{isAuthenticated &&
					<Menu closeOnSelect={false}>
						<MenuButton
							as={IconButton}
							aria-label="Options"
							icon={
								<Avatar boxSize="10" name={user?.displayName} />
							}
							variant="ghost"
							_active={{
								bg: 'none'
							}}
						/>
                        <MenuList>
                            <MenuItem icon={<Settings />} isDisabled={!isAdmin} onClick={() => {
                                if (isAdmin) navigate('/settings');
                            }}>
                                Settings
                            </MenuItem>
                            {isAdmin && (
                                <MenuItem icon={<Shield />} onClick={() => navigate('/admin')}>
                                    Admin
                                </MenuItem>
                            )}
                            {canManageProducts && (
                                <MenuItem icon={<Database />} onClick={() => navigate('/admin/products')}>
                                    Product Data
                                </MenuItem>
                            )}
                            {!inCadMode && (
                                <MenuItem icon={<Hammer />} onClick={() => navigate('/r', { replace: true })}>
                                    Cad Editor
                                </MenuItem>
                            )}
							<MenuItem
								onClick={toggleColorMode}
								icon={<SwitchIcon />}
							>
								Change to {text} mode
							</MenuItem>
							<MenuDivider />
							<MenuItem
								icon={<LogOut />}
								onClick={() => signOut()}
							>
								Logout
							</MenuItem>
						</MenuList>
					</Menu>
				}
				{!isAuthenticated && <Avatar boxSize="10" />}
			</HStack>
		</Box>
	</>);
};
